import Api from "../../config/Api";
import { ArrTypeResponse, Type, TypeResponse } from "./type";
import { Respone } from "../../config/type";

const PATH = "/types";
async function getAllType(): Promise<ArrTypeResponse> {
  // Navigation needs all category names; each response is bounded and products
  // are never fetched here. Follow metadata instead of relying on an unlimited API.
  const data: Type[] = [];
  for (let page = 1; page <= 1000; page++) {
    const response = await Api.get(PATH, { params: { page, perPage: 100 } });
    data.push(...response.data.data);
    if (!response.data.meta.hasMore) return { ...response.data, data };
  }
  throw new Error("Danh mục vượt giới hạn phân trang");
}

async function getTypeById(_id: string): Promise<TypeResponse> {
  const response = await Api.get(`${PATH}/${_id}`);

  return response.data;
}

async function addNewType(type: Type): Promise<TypeResponse> {
  const response = await Api.post(PATH, type);

  return response.data;
}

async function updateType(newType: Type): Promise<Respone> {
  const response = await Api.put(`${PATH}/${newType._id}`, newType);

  return response.data;
}

async function destroyType(_id: string): Promise<void> {
  const response = await Api.delete(`${PATH}/${_id}`);

  return response.data;
}

export default {
  getAllType,
  getTypeById,
  addNewType,
  updateType,
  destroyType,
};
